/*
 * 进行local数据存储管理的工具模块
 */
const obj = {}
export default {
    /*
     * 设置值
     */
    set (key,val) {
        try {
            if(sessionStorage.getItem('open_session') && sessionStorage.getItem('open_session') === '1'){
                sessionStorage.setItem(key, JSON.stringify(val))
            }else{
                sessionStorage.setItem(key, JSON.stringify(val)) //改为redux储存
            }
        }catch(e){
            obj[key] = val
        }
    },

    /*
     * 读取值
     */
    get (key) {
        try {
            if(sessionStorage.getItem('open_session') && sessionStorage.getItem('open_session') === '1'){
                if(!sessionStorage.getItem(key))throw Error
                return JSON.parse(sessionStorage.getItem(key))
            }else{
                if(!sessionStorage.getItem(key))throw Error
                return JSON.parse(sessionStorage.getItem(key))
            }
        }catch(e){
            return obj[key]
        }

    },

    /*
     * 删除值
     */
    remove (key) {
        try{
            if(sessionStorage.getItem('open_session') && sessionStorage.getItem('open_session') === '1'){
                sessionStorage.removeItem(key)
            }else{
                sessionStorage.removeItem(key)
            }
        }catch(e){
            // obj.splice(key, 1)
            delete obj[key]
        }

    }
}